/* eslint-disable func-names, space-before-function-paren, wrap-iife */

(function() {
  this.ProjectShow = (function() {
    function ProjectShow() {}

    return ProjectShow;
  })();
}).call(window);

// I kept class for future



// WEBPACK FOOTER //
// ./project_show.js